<template>
  <div v-show="offersDetails.length">
    <table class="slds-table slds-no-row-hover slds-table_bordered">
      <thead>
        <tr class="slds-line-height_reset">
          <th scope="col">
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.offer')">
              {{$t('campaignDesigner.contentSelectionAndTag.offer')}}
            </div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.startDate')">
              {{$t('campaignDesigner.contentSelectionAndTag.startDate')}}
            </div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.endDate')">
              {{$t('campaignDesigner.contentSelectionAndTag.endDate')}}
            </div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.masterKey')">
              {{$t('campaignDesigner.contentSelectionAndTag.masterKey')}}
            </div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.brand')">
              {{$t('campaignDesigner.contentSelectionAndTag.brand')}}
            </div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.fleet')">
              {{$t('campaignDesigner.contentSelectionAndTag.fleet')}}
            </div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.kmFrom')">{{$t('campaignDesigner.contentSelectionAndTag.kmFrom')}}</div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.kmTo')">{{$t('campaignDesigner.contentSelectionAndTag.kmTo')}}</div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.carAge')">{{$t('campaignDesigner.contentSelectionAndTag.carAge')}}</div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.tag')">
              {{$t('campaignDesigner.contentSelectionAndTag.contentPriority.label')}}
            </div>
          </th>
          <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.tag')">
              {{$t('campaignDesigner.contentSelectionAndTag.tag')}}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(offer, index) in offersDetails">
          <OffersTableRow
            :collapsed="!expandedOffers.includes(index)"
            :editable="editable"
            :key="`offerTableRow_${index}`"
            :index="index"
            :offer="offer"
            :ref="`row_${index}`"
            :tags="tags"
            @removeOffer="$emit('removeOffer', $event)"
            @showDetails="offerModal = $event.index"
            @toggleCollapse="toggleCollapse"
            @tagUpdate="onTagUpdate"
            @update-content-priority="$emit('update-content-priority', $event)"/>

            <OfferItems :offer="offer" :show="expandedOffers.includes(index)" :key="`row_${index}`" />
            <VINMVSModal v-if="offerModal === index" :offer="offer" :key="`modal_${index}`" @closeModal="offerModal = -1" :mvs-names="mvsNames" />
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import { toggleInArray } from '../../../utils/utils'
import { getMvsNameByMvs as getMvsName, getDb } from '../../../utils/indexedDbUtils'

import OfferItems from './OfferItems'
import OffersTableRow from './OffersTableRow'
import VINMVSModal from './VINMVSModal'
import Validator from '../../../../validation/Validator'
export default {
  mixins: [Validator],
  components: {
    OfferItems,
    OffersTableRow,
    VINMVSModal
  },
  async created () {
    await this.mapOffersDetails(this.offers)
  },
  data () {
    return {
      expandedOffers: [],
      mvsNames: {},
      offerModal: -1,
      offersDetails: []
    }
  },
  methods: {
    async mapMvsName () {
      const objects = new Set()
      this.offersDetails.forEach(offer => {
        if (offer.mmvsList && offer.mmvsList.length) {
          offer.mmvsList.forEach(mmvs => {
            objects.add(mmvs)
          })
        }
      })
      const db = await getDb()
      const names = await Promise.all(
        Array.from(objects).map(v => {
          return getMvsName(v, db)
        })
      )

      return names
        .filter(e => !!e)
        .reduce((acc, val) => {
          acc[val.mvs] = val.label
          return acc
        }, {})
    },
    async mapOffersDetails (offers) {
      this.offersDetails = offers
      this.mvsNames = await this.mapMvsName()
    },
    onTagUpdate (event) {
      const { index, position, value } = event
      this.$emit('tagUpdate', { index, position, value })
    },
    toggleCollapse (event) {
      toggleInArray(this.expandedOffers, event.index)
    },
    validate () {
      return Object.values(this.$refs).every(ref => ref.every(child => child.validate()))
    }
  },
  props: {
    editable: Boolean,
    offers: Array,
    tags: Array
  },
  watch: {
    offers (offers) {
      this.mapOffersDetails(offers)
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #005FAA !important;
    color: white !important;
  }
</style>
